import { Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from '@mui/material';
import { TabsNav, SelectNav, IOperationAllow } from '../common';
import { diLabels } from '.';

export const DiNav = ({
  currentTab,
  operations,
  setCurrentTab,
}: {
  currentTab: number;
  operations: IOperationAllow[];
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const matchesTabsBreakpoint = useMediaQuery('(min-width:40em)', {
    noSsr: true,
  });

  return matchesTabsBreakpoint ? (
    <TabsNav
      currentTab={currentTab}
      labels={diLabels(operations)}
      onChange={setCurrentTab}
      ariaLabel="di tabs"
    />
  ) : (
    <SelectNav
      currentTab={currentTab}
      labels={diLabels(operations)}
      onChange={setCurrentTab}
      ariaLabel="di tabs"
    />
  );
};
